export default __webpack_public_path__ + "static/media/htbabyImg4.95a4c83e.png";